import React from 'react'
import SliderOutTeam from '../../component/slidercomponent/SliderOutTeam'
import SliderOurTeam from '../../component/slidercomponent/SliderOurTeam'
import { Link } from "react-router-dom";


const OutTeam = () => {
    return (
        <>
            
              <section className="content-inner">
                <div className="container">
                    <div className="section-head style-1 m-b30 row align-items-end">
                        <div className="col-sm-7 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'none' }}>
                            <h2 className="title m-b0">We Employ only <br /> Specialists </h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'none' }}>
                            <div className="dz-team style-1 active box-hover">
                                <div className="dz-media">
                                    <img src="./assets/images/team/img1.webp" alt="/" />
                                    <a to="appointment.html" className="btn btn-primary">
                                        <i className="feather icon-calendar m-r5" />
                                        Appointment Now
                                    </a>
                                </div>
                                <div className="dz-content">
                                    <div className="clearfix">
                                        <h3 className="dz-name"><a to="team-detail.html">Nashid Martines</a></h3>
                                        <span className="dz-position">Cardiac Surgery</span>
                                    </div>
                                    <a to="team-detail.html" className="btn btn-square btn-secondary">
                                        <i className="feather icon-arrow-right" />
                                    </a>
                                </div>
                                <ul className="dz-social">
                                    <li>
                                        <a to="https://www.linkedin.com" target="_blank">
                                            <i className="fa-brands fa-linkedin" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.instagram.com" target="_blank">
                                            <i className="fa-brands fa-instagram" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.facebook.com" target="_blank">
                                            <i className="fa-brands fa-facebook-f" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://twitter.com" target="_blank">
                                            <i className="fa-brands fa-x-twitter" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.youtube.com" target="_blank">
                                            <i className="fa-brands fa-youtube" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'none' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/images/team/img2.webp" alt="/" />
                                    <a to="appointment.html" className="btn btn-primary">
                                        <i className="feather icon-calendar m-r5" />
                                        Appointment Now
                                    </a>
                                </div>
                                <div className="dz-content">
                                    <div className="clearfix">
                                        <h3 className="dz-name"><a to="team-detail.html">Danial Frankie</a></h3>
                                        <span className="dz-position">Pediatric Clinic</span>
                                    </div>
                                    <a to="team-detail.html" className="btn btn-square btn-secondary">
                                        <i className="feather icon-arrow-right" />
                                    </a>
                                </div>
                                <ul className="dz-social">
                                    <li>
                                        <a to="https://www.linkedin.com" target="_blank">
                                            <i className="fa-brands fa-linkedin" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.instagram.com" target="_blank">
                                            <i className="fa-brands fa-instagram" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.facebook.com" target="_blank">
                                            <i className="fa-brands fa-facebook-f" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://twitter.com" target="_blank">
                                            <i className="fa-brands fa-x-twitter" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.youtube.com" target="_blank">
                                            <i className="fa-brands fa-youtube" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.6s" data-wow-duration="0.8s" style={{ animationDuration: '0.8s', animationDelay: '0.6s', animationName: 'none' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/images/team/img3.webp" alt="/" />
                                    <a to="appointment.html" className="btn btn-primary">
                                        <i className="feather icon-calendar m-r5" />
                                        Appointment Now
                                    </a>
                                </div>
                                <div className="dz-content">
                                    <div className="clearfix">
                                        <h3 className="dz-name"><a to="team-detail.html">Rihana Roy</a></h3>
                                        <span className="dz-position">Gynecology</span>
                                    </div>
                                    <a to="team-detail.html" className="btn btn-square btn-secondary">
                                        <i className="feather icon-arrow-right" />
                                    </a>
                                </div>
                                <ul className="dz-social">
                                    <li>
                                        <a to="https://www.linkedin.com" target="_blank">
                                            <i className="fa-brands fa-linkedin" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.instagram.com" target="_blank">
                                            <i className="fa-brands fa-instagram" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.facebook.com" target="_blank">
                                            <i className="fa-brands fa-facebook-f" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://twitter.com" target="_blank">
                                            <i className="fa-brands fa-x-twitter" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.youtube.com" target="_blank">
                                            <i className="fa-brands fa-youtube" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.8s" data-wow-duration="0.8s" style={{ animationDuration: '0.8s', animationDelay: '0.8s', animationName: 'none' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/images/team/img4.webp" alt="/" />
                                    <a to="appointment.html" className="btn btn-primary">
                                        <i className="feather icon-calendar m-r5" />
                                        Appointment Now
                                    </a>
                                </div>
                                <div className="dz-content">
                                    <div className="clearfix">
                                        <h3 className="dz-name"><a to="team-detail.html">Kenneth Fong</a></h3>
                                        <span className="dz-position">Neurology</span>
                                    </div>
                                    <a to="team-detail.html" className="btn btn-square btn-secondary">
                                        <i className="feather icon-arrow-right" />
                                    </a>
                                </div>
                                <ul className="dz-social">
                                    <li>
                                        <a to="https://www.linkedin.com" target="_blank">
                                            <i className="fa-brands fa-linkedin" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.instagram.com" target="_blank">
                                            <i className="fa-brands fa-instagram" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.facebook.com" target="_blank">
                                            <i className="fa-brands fa-facebook-f" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://twitter.com" target="_blank">
                                            <i className="fa-brands fa-x-twitter" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.youtube.com" target="_blank">
                                            <i className="fa-brands fa-youtube" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default OutTeam